import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PaymentModal from './PaymentModal';
import logo from '../logo.jpg';
import './ReservationPage.css';

const fullDateFormat = (shortDate) => {
  if (!shortDate) return '';
  const parts = shortDate.split(', ');
  const dayName = parts[0];
  const dateStr = parts[1].split(' ');
  const day = dateStr[0];
  const month = dateStr[1];
  return `${dayName}day ${day} ${month} 2025`;
};

const ReservationPage = () => {
  const navigate = useNavigate();
  const [reservation, setReservation] = useState({});
  const [showPayment, setShowPayment] = useState(false);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('pierchicReservation') || '{}');
    // guests сохраняем из localStorage, если есть
    const guests = localStorage.getItem('pierchicGuests');
    setReservation({ ...data, guests: guests ? Number(guests) : (data.guests || 2) });
  }, []);

  return (
    <div>
      <div className="reservation-logo-bar">
        <img src={logo} alt="Pierchic Logo" className="reservation-logo-img" />
      </div>
      <div className="reservation-page">
        <div className="reservation-header">
          <button className="back-button" onClick={() => navigate('/')}>←</button>
          <div className="reservation-summary reservation-summary-bar">
            <span>Pierchic</span>
            <span>•</span>
            <span>{reservation.date || 'Tue, 20 May'}</span>
            <span>•</span>
            <span>{reservation.time || '13:30'}</span>
            <span>•</span>
            <span>{reservation.guests || 2} guests</span>
            <span>•</span>
            <span style={{display:'inline-flex', alignItems:'center'}}><svg width="18" height="18" viewBox="0 0 20 20" style={{marginRight:3}}><circle cx="10" cy="10" r="9" stroke="#222" strokeWidth="1.5" fill="none"/><path d="M10 5v5l3 3" stroke="#222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>3:30</span>
          </div>
        </div>
        <div className="reservation-layout">
          <div className="reservation-form">
            <div className="form-section">
              <h3 className="form-section-title">Your information</h3>
              <p>Please select an option below to continue checkout:</p>
              <div className="form-divider">
                <span>Or continue as a guest</span>
              </div>
              <div className="form-group">
                <label className="form-label">First Name*</label>
                <input type="text" className="form-control" placeholder="First Name" />
              </div>
              <div className="form-group">
                <label className="form-label">Last Name*</label>
                <input type="text" className="form-control" placeholder="Last Name" />
              </div>
              <div className="form-group">
                <label className="form-label">Email Address*</label>
                <input type="email" className="form-control" placeholder="Email Address" />
              </div>
              <div className="form-group">
                <label className="form-label">Phone Number*</label>
                <input type="tel" className="form-control" placeholder="Phone Number" />
              </div>
            </div>
            <div className="form-section">
              <p>If you'd like, tell us more about yourself and your preferences so we can provide a better experience.</p>
              <div className="form-group">
                <input type="text" className="form-control" placeholder="Anything else we should know?" />
              </div>
              <div className="form-group" style={{display:'flex', alignItems:'center', gap:8}}>
                <input type="checkbox" id="cancellation" />
                <label htmlFor="cancellation" style={{marginBottom:0}}>Cancellation Policy*</label>
                <span className="info-icon" title="Read the cancellation policy"><svg width="20" height="20" viewBox="0 0 20 20" style={{verticalAlign:'middle'}}><circle cx="10" cy="10" r="9" stroke="#222" strokeWidth="1.5" fill="none"/><text x="10" y="15" textAnchor="middle" fontSize="13" fill="#222" fontFamily="Arial" fontWeight="bold">i</text></svg></span>
              </div>
            </div>




            <button className="pay-btn" onClick={() => setShowPayment(true)} style={{marginTop: 28, marginBottom: 8}}>Proceed to Payment</button>
            <div className="pay-terms-text">
              By clicking "submit" you agree to SevenRooms' <a href="https://sevenrooms.com/en/legal/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="https://sevenrooms.com/en/legal/gdpr" target="_blank" rel="noopener noreferrer">GDPR Policy</a>.
            </div>
          </div>
          <div className="reservation-map">
            <div className="map-container-small">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3612.238722352548!2d55.18556031501047!3d25.141169983933885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6834bdfa3c5d%3A0x2e1a5f1b3b3e1b1a!2sAl%20Qasr%20Hotel!5e0!3m2!1sen!2sae!4v1623345678901!5m2!1sen!2sae"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Restaurant location"
              ></iframe>
            </div>
            <h3>Pierchic</h3>
            <div className="reservation-details">
              <div className="reservation-detail-item">
                <div className="reservation-detail-icon"><i className="fas fa-calendar"></i></div>
                <div id="mapDate">{fullDateFormat(reservation.date) || 'Tuesday 20 May 2025'}</div>
              </div>
              <div className="reservation-detail-item">
                <div className="reservation-detail-icon"><i className="fas fa-clock"></i></div>
                <div id="mapTime">{reservation.time}<br />{reservation.type}</div>
              </div>
              <div className="reservation-detail-item">
                <div className="reservation-detail-icon"><i className="fas fa-user"></i></div>
                <div>Party of {reservation.guests || 2}</div>
              </div>
            </div>
          </div>
        </div>
        <PaymentModal open={showPayment} onClose={() => setShowPayment(false)} />
      </div>
    </div>
  );
};

export default ReservationPage; 